function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { colors } from '../theme/index.js';
import { styled } from '@mui/system';
const BlockRowStyled = styled('div')({
  alignItems: 'center',
  backgroundColor: colors.surface,
  cursor: 'pointer',
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  height: 60,
  marginBottom: 5,
  boxShadow: "0 1px 2px rgb(0 0 0 / 15%)",
  '&:hover': {
    filter: "brightness(97%)"
  }
});

/**
 * 
 * @param {*} props 
 * @returns 
 */
const BlockRow = props => {
  const style = {
    borderLeft: props.selected && `5px solid ${colors.skyBlue}`,
    ...props.style
  };
  return /*#__PURE__*/React.createElement(BlockRowStyled, _extends({}, props, {
    style: style
  }), props.children);
};
export default BlockRow;